import * as React from "react"

const Icon = (props) => {
  return (
    <svg
      data-name="Group 56"
      xmlns="http://www.w3.org/2000/svg"
      width={49.737}
      height={38.425}
      {...props}
    >
      <g data-name="Group 55">
        <path
          data-name="Path 37"
          d="M0 20.144l2.823 1.412v6.291L0 26.435zm19.381 10.89L4.6 23.643v-1.2l14.781 7.391zM4.6 25.63l14.781 7.391v3.1L4.6 28.735zm16.557 5.092l2.823 1.412v6.291l-2.823-1.412zm4.6 1.412l2.823-1.412v6.291l-2.823 1.412zm19.381-8.49l-14.782 7.39v-1.2l14.781-7.391zm-14.782 9.377l14.781-7.391v3.1l-14.781 7.395zm16.557-11.466l2.823-1.412v6.291l-2.823 1.412zM7.993 9.326l2.664 1.332v3.91a.888.888 0 101.776 0v-3.022l2.667 1.336v8.672l-7.107-3.557zm7.993-4.885l2.474 1.241-6.9 3.448-2.469-1.241zm15.777-.993l-6.9 3.448-2.431-1.214 6.9-3.448zm4.46 2.234l-6.9 3.448-2.468-1.241 6.9-3.448zm4.422 2.211l-6.9 3.448-2.436-1.218 6.9-3.448zm-27.095 2.23l6.9-3.448 2.436 1.218-6.9 3.448zm11.318-1.241l2.473 1.237-6.9 3.448-2.473-1.237zm-2.436 5.677l6.9-3.448 2.436 1.218-6.9 3.448zm-5.557-.453v-.339l2.664 1.332v3.91a.888.888 0 001.776 0v-3.027l2.664 1.332v8.672l-7.105-3.553zm8.882 4.441v-1.228l7.105-3.553v8.672l-7.105 3.553zm8.882-4.441v-1.224l7.105-3.553v8.672l-7.105 3.553zM24.868 0l2.473 1.237-6.895 3.445-2.473-1.234zM6.217 16.147v2.4a.888.888 0 00.491.794l8.882 4.441 8.882 4.441c.013.006.028 0 .041.01a.8.8 0 00.712 0c.013-.006.028 0 .041-.01l8.881-4.441 8.882-4.441a.888.888 0 00.491-.794v-2.4l5.119 2.56-23.771 11.885L1.1 18.707z"
          fill="#30698d"
        />
      </g>
    </svg>
  )
}

export default Icon

